export default {
  getters: {
    getPartner: state => state.partner,
  },
  mutations: {
    clearPartner(state) {
      state.partner = null
    },
    setPartner(state, value) {
      state.partner = value
    },
  },
  state: {
    partner: null,
  }
}
